import { createFileRoute } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import { Page } from "@/components/Page";
import { Terms } from "@/components/Terms";

export const Route = createFileRoute(
  "/_marketing-header-layout/terms-and-conditions",
)({
  component: RouteComponent,
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Terms & Conditions | Graze",
      ogTitle: "Terms & Conditions",
      description: "Terms & Conditions for Graze.social",
      pathname,
    }),
});

function RouteComponent() {
  return (
    <Page className="md:max-w-240">
      <h1 className="text-4xl md:text-6xl font-bold instrument-serif">
        Terms & Conditions
      </h1>
      <Terms />
    </Page>
  );
}
